import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserContext } from './Context';

const checkCustomer = localStorage.getItem('customer_login');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Router>
    <UserContext.Provider value={{
        'login' : checkCustomer
      }}>
        <App />
      </UserContext.Provider>
    </Router>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
